export default __webpack_public_path__ + "static/media/icon.f1dcc2e0.png";